import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDoubleRight } from '@fortawesome/pro-solid-svg-icons';

import * as api from 'helpers/api';
import { Modal, ProgressBar } from 'react-bootstrap-5';
import { Button } from 'components/ui/button';

export class DuplicationForm extends React.Component {
  static propTypes = {
    propertyId: PropTypes.number.isRequired,
    propertyTitle: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired
  }

  state = {
    duplicating: false,
    duplicationId: null,
    duplicationStatus: null,
    percentComplete: 0,
    statusUrl: null
  }

  pollDuplicationStatus = () => {
    api.get(this.state.statusUrl).then((data) => {
      this.setState({
        percentComplete: data.percentComplete,
        duplicationStatus: data.status
      });

      if (data.percentComplete >= 100) {
        window.location = data.url;
        return;
      }

      setTimeout(this.pollDuplicationStatus, 1000);
    });
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
  }

  handleSubmit = () => {
    this.setState({ duplicating: true, duplicationStatus: 'Preparing to duplicate' });
    const data = { existingResearchPropertyId: this.props.propertyId };
    api.post('/research/property_duplications', data).then((response) => {
      this.setState({ duplicationId: response.id, statusUrl: response.statusUrl });
      this.pollDuplicationStatus();
    });
  }

  renderStatus() {
    return (
      <div>
        <h6>{this.state.duplicationStatus}</h6>
        <ProgressBar active now={this.state.percentComplete} />
      </div>
    );
  }

  renderModalBody() {
    if (this.state.duplicating) {
      return this.renderStatus();
    }
    return (
      <>
        <div className="d-flex mb-2 gap-3">
          <div>
            <FontAwesomeIcon className="text-primary" icon={faChevronDoubleRight} size="sm" />
          </div>
          <div>
            <strong>Property Information</strong>
            <p>Property Information, Location Information, Building, Land, Multifamily Information and Media</p>
          </div>
        </div>
        <div className="d-flex gap-3">
          <div>
            <FontAwesomeIcon className="text-primary" icon={faChevronDoubleRight} size="sm" />
          </div>
          <div>
            <strong>Related Data</strong>
            <p>Activities and Tasks, Groups, Tags, Related Contacts, Sale and Lease Comps and Listings</p>
          </div>
        </div>
      </>
    );
  }

  render() {
    return (
      <Modal centered show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <h6>
            Duplicate {this.props.propertyTitle}
          </h6>
        </Modal.Header>
        <Modal.Body>
          {this.renderModalBody()}
        </Modal.Body>
        {!this.state.duplicating && 
          <Modal.Footer>
            <Button label="Cancel" variant="ghost" onClick={this.props.onHide} />
            <Button label="Duplicate Property" onClick={this.handleSubmit} />
          </Modal.Footer>}
      </Modal>
    );
  }
}

export default DuplicationForm;
